// import { PaymentMethods, PaymentMethodsTranslate } from '@/enums';
import { Actions } from 'vuex-smart-module';
import { ResponseStatuses, RepairStatuses } from '@/enums';
import { AxiosResponse } from 'axios';
import { Repairs } from '@/modules/repairs/types';
import NewRepairGetters from './getters';
import NewRepairMutations from './mutations';
import { RepairsService } from '../../../services';
import NewRepairState from './state';

const repairsService = new RepairsService();

export default class NewRepairActions extends Actions<
  NewRepairState,
  NewRepairGetters,
  NewRepairMutations,
  NewRepairActions
> {
  async get_new_repair_categories() {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await repairsService.get_new_repair_categories();

      this.mutations.SET_NEW_REPAIR_CATEGORIES(data.items);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async get_new_repair_operation_types() {
    try {
      const { serial_number, organization_id } = this.state.new_repair;
      const response = await repairsService.get_new_repair_operation_types(serial_number, organization_id);
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = response;

      this.mutations.SET_NEW_REPAIR_OPERATION_TYPES(data.items);
      this.mutations.SET_NEW_REPAIR_WARRANTY_IS_NOT(data.is_not_warranty_repair);
      this.mutations.SET_IN_NOT_FOUND(data.is_not_found);

      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async get_new_repair_warranty(serial_number: number | string) {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await repairsService.check_warranty(serial_number);

      this.mutations.SET_NEW_REPAIR_WARRANTY(data);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async send_new_repair() {
    try {
      const { new_repair } = this.state;

      const { data, code } = await repairsService.send_new_repair(new_repair);

      this.mutations.UPD_NEW_REPAIR_KEY({ key: 'id', value: data.order_side_id });
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async edit_new_repair(id: string | number) {
    try {
      const { new_repair } = this.state;

      const { code } = await repairsService.edit_new_repair(id, new_repair);

      return { code, success: true };
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }
}
